<div class="uploadWrapper">
  <div class="stepperWrapp fullVh">
    <div class="finalQuote">
      <ng-container *ngIf="showDragDrop; else elseTemplate">
        <div
          class="file-uploader flex flex-column align-items-center justify-content-center dropzone"
          appDnd
          #fileDropRef
          id="fileDropRef"
          (fileDropped)="onFileDropped($event)"
          *ngIf="fileUploadConfig.isMultiple || !files?.length"
        >
          <input
            type="file"
            [multiple]="fileUploadConfig.isMultiple"
            [accept]="fileUploadConfig.fileFormats"
            #fileSelector
            (change)="fileBrowseHandler($event)"
            style="display: none"
          />
          <h4 class="file-uploader-label">{{ fileUploadConfig.uploadLabel }}</h4>
          <p class="file-uploader-size-label">{{ fileUploadConfig.maxFileText }}</p>
          <p class="file-uploader-drag-drop-label">{{ fileUploadConfig.dragDropText }}</p>
          <p class="choose-file-button" (click)="chooseFiles()">{{ fileUploadConfig.buttonName }}</p>
          <p class="file-uploader-accept-File-Ext-label">{{fileUploadConfig?.acceptFileTxt}}</p>
        </div>
      </ng-container>
      <ng-template #elseTemplate>
        <div class="inline-flex flex-column align-items-center justify-content-center dropzone" *ngIf="!files?.length">
          <input
            type="file"
            [multiple]="fileUploadConfig.isMultiple"
            [accept]="fileUploadConfig.fileFormats"
            #fileSelector
            (change)="fileBrowseHandler($event)"
            style="display: none"
          />
          <h4 class="file-uploader-label">{{ fileUploadConfig.uploadLabel }}</h4>
          <!-- <p class="file-uploader-size-label-1">{{ fileUploadConfig.maxFileText }}</p> -->
          <p class="choose-file-button-1" (click)="chooseFiles()">{{ fileUploadConfig.buttonName }}</p>
        </div>
      </ng-template>

      <div class="uplodedfile" *ngIf="files?.length && showDragDrop && !fileUploadConfig.isMultiple">
        <div class="fileIcon">
          <svg xmlns="http://www.w3.org/2000/svg" width="62" height="62" viewBox="0 0 62 62" fill="none">
            <path
              d="M51.3689 31V15.0829C51.3689 14.6778 51.208 14.2892 50.9215 14.0027L42.9049 5.98614C42.6184 5.69965 42.2299 5.5387 41.8247 5.5387H12.6309C11.5263 5.5387 10.6309 6.43413 10.6309 7.5387V54.4613C10.6309 55.5659 11.5263 56.4613 12.6309 56.4613H28.4538"
              stroke="#666666"
              stroke-width="2.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M20.8154 25.9077H41.1845M20.8154 15.7231H30.9999M20.8154 36.0922H28.4538"
              stroke="#666666"
              stroke-width="2.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M41.1846 5.5387V14.1955C41.1846 15.0393 41.8685 15.7232 42.7122 15.7232H51.3691"
              stroke="#666666"
              stroke-width="2.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M44.3217 37.311C38.533 37.311 33.8403 42.0037 33.8403 47.7924C33.8403 53.5812 38.533 58.2739 44.3217 58.2739C50.1105 58.2739 54.8031 53.5812 54.8031 47.7924C54.8031 42.0037 50.1105 37.311 44.3217 37.311ZM39.9639 47.7629C39.6783 47.4773 39.2153 47.4773 38.9297 47.7629C38.6441 48.0485 38.6441 48.5115 38.9297 48.797L41.8547 51.7221C42.1403 52.0077 42.6033 52.0077 42.8889 51.7221L49.714 44.897C49.9996 44.6114 49.9996 44.1484 49.714 43.8628C49.4284 43.5772 48.9654 43.5772 48.6798 43.8628L42.3718 50.1708L39.9639 47.7629Z"
              fill="#298135"
            />
          </svg>
        </div>
        <h3>Uploaded</h3>
      </div>
      <div class="files-list">
        <div class="single-file flex justify-content-between" *ngFor="let file of files; let i = index">
          <div class="fileInfo">
            <lucide-icon name="FileText" class="icon"></lucide-icon>
              <div class="fileDesc">
                <h4 class="name" matTooltip="{{ file?.name }}" [matTooltipPosition]="'right'">
                  {{ file?.name }}.<span class="name">{{ file?.fileType }}</span>
                </h4>
                <span class="name">{{ formatBytes(file?.size) }}</span>
              </div>
          </div>
          <span (click)="deleteFile(i)" class="rfqItem rfqDownloadIco">
            <lucide-icon name="Trash" class="icon"></lucide-icon>
          </span>
          <!-- <div><p class="size">{{ formatBytes(file?.size) }}</p></div> -->
          <!-- <button (click)="deleteFile(i)" mat-icon-button color="warn" aria-label="Delete File">  
          </button> -->          
        </div>
      </div>
    </div>
  </div>
</div>
